import { Observable } from 'rxjs';
import { AuthRepository } from '../domain/auth/repository';

import HttpClient from '../utils/http-client';

export class AuthRepositoryImplementation extends AuthRepository {
  signInWithEmailAndPassword(email: string, password: string): Observable<any> {
    const httpClient = new HttpClient("", "");
    return httpClient.post_no_refresh<any>(`/auth/signin`, { email, password });
  }

  refreshToken(token: string): Observable<any> {
    const httpClient = new HttpClient("", "");
    return httpClient.post_no_refresh<any>(`/auth/refresh`, { token });
  }
}
